import chroma from "chroma-js";
function opacify(color, alpha) {
  if (color === "transparent") {
    return color;
  }
  return chroma(color).alpha(alpha).hex();
}
export default opacify;
